import posthog from 'posthog-js';

const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
// `||`, not `??`: the Docker build declares these as empty-string ARGs, and an
// empty api_host would send every event to our own origin.
// t.toiyp.me is our reverse proxy to PostHog EU: first-party, so ad blockers
// leave it alone.
const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://t.toiyp.me';

if (key) {
  posthog.init(key, {
    api_host: host,
    // Behind a proxy PostHog can't infer its own app URL, which the toolbar and
    // links back into the dashboard need.
    ui_host: 'https://eu.posthog.com',
    defaults: '2026-05-30',
    capture_pageview: false,
    capture_pageleave: false,
    // Uncaught errors and unhandled rejections land in Error tracking. React
    // render errors are caught by the boundary in main.tsx instead.
    capture_exceptions: true,
    persistence: 'localStorage+cookie',
  });
} else if (import.meta.env.PROD) {
  console.warn('[posthog] VITE_POSTHOG_KEY was not set at build time — analytics disabled');
}

export { posthog };
